import { lazy } from "react";
import Admin from "../pages/Admin";
import Calculator from "../pages/Calculator";
import Homepage from "../pages/Homepage";
import ProductPage from "../pages/ProductPage";
import { 
    ADMIN_ROUTE,
    AUTH_ROUTE,
    CALCULATOR_ROUTE,
    HOMEPAGE_ROUTE,
    MULTICOLORS_ROUTE,
    PLAIN_ROTE,
    PRODUCT_ROUTE,
    MIXED_PRODUCT_ROUTE,
    UPDATE_BRICK,
    NOT_FOUND 
    } from "./consts";

import Auth from "../pages/Auth";
import UpdateBrick from "../components/Modals/UpdateBrick";
import NotFoundPage from "../pages/NotFoundPage";

// const MonoColor = lazy(()=> import('../pages/Bricks/MonoColor'))
// const MultiColors = lazy(()=> import('../pages/Bricks/MultiColors'))
const BrickCatalog = lazy(() => import('../pages/Bricks/BrickCatalog'))

export const routes = [
    {
        path: HOMEPAGE_ROUTE,
        Component: Homepage
    },
    {
        path:CALCULATOR_ROUTE,
        Component: Calculator
    },
    {
        path:MULTICOLORS_ROUTE,
        Component:BrickCatalog
    },
    {
        path:PLAIN_ROTE,
        Component:BrickCatalog
    },
    {
        path:PRODUCT_ROUTE + '/:id',
        Component:ProductPage
    },
    {
        path:MIXED_PRODUCT_ROUTE + '/:id',
        Component: ProductPage
    },
    {
        path:ADMIN_ROUTE,
        Component: Admin
    },
    {
        path:AUTH_ROUTE,
        Component:Auth
    },
    {
        path: UPDATE_BRICK + '/:id',
        Component: UpdateBrick
    },
    {
        path: NOT_FOUND,
        Component: NotFoundPage
    }
]